module.exports = __webpack_public_path__ + "media/images/amenities_icons/workshop-3d511858996b5162059b5c4d42b6a923.svg";